import type {ReactElement} from 'react';
import {Text, TextSize, TextType} from '@Components/text';
import {NEW_SUBSCRIPTION_START_SOURCE_COOKIE, NewSubscriptionStartSource} from '@Libraries/ga-events';
import {isUserPAYG} from '@Libraries/user.library';
import {openPremiumPricingModal} from '@Modals/premium-pricing-modal/premium-pricing-modal.library';
import {COOKIE_EXPIRY_30_MINUTES, setCookie} from '@Utils/cookie.util';
import styles from './version-history-premium-notice.module.scss';

export function VersionHistoryPremiumNotice(): ReactElement | null {
  const onUpgradeClick = (): void => {
    setCookie(NEW_SUBSCRIPTION_START_SOURCE_COOKIE, NewSubscriptionStartSource.VERSION_HISTORY_UPGRADE_BUTTON, COOKIE_EXPIRY_30_MINUTES);
    openPremiumPricingModal(false);
  };

  if (!isUserPAYG()) {
    return null;
  }

  return (
    <div className={`flexbox flex-items-center gap-0 ${styles.premiumNotice}`}>
      <div>
        <Text val={window.i18next.t('pmwjs_version_history_limited')} type={TextType.BODY} size={TextSize.MD} bold />
        <br />
        <Text val={window.i18next.t('pmwjs_unlock_premium_version_history')} type={TextType.BODY} size={TextSize.MD} />
        <Text val={window.i18next.t('pmwjs_upgrade')} className={styles.upgradeLink} type={TextType.BODY} size={TextSize.MD} underline onClick={onUpgradeClick} />
      </div>
    </div>
  );
}
